import React, { memo, useMemo } from 'react';
import { TimeSignalDimensionType } from 'graphql/types';
import { useGetTimeSignalAnalyticsData } from 'modules/Insights/Notes/hooks/useGetTimeSignalAnalyticsData';
import { transformLabelData } from './utils';
import ProjectComponent from './ProjectComponent';

export const ProjectChart: React.FC = () => {
  const { data, loading = true, isEmpty } = useGetTimeSignalAnalyticsData(
    TimeSignalDimensionType.MetricsByProject
  );
  const dataset = useMemo(() => {
    if (isEmpty) {
      return [];
    } else {
      return transformLabelData(data?.timeSignalAnalytics?.items, 'PROJECT');
    }
  }, [data?.timeSignalAnalytics?.items, isEmpty]);

  return (
    <ProjectComponent data={dataset} loading={loading} isEmpty={isEmpty} />
  );
};
export default memo(ProjectChart);
